import { getNumberOfFiltersApplied as getNumberOfFiltersAppliedSelector } from '@vista/omnichannel-components-domain';
export const getNumberOfFiltersApplied = (props) => {
    return getNumberOfFiltersAppliedSelector(props);
};
